import React, { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useSystemLanguages } from "../queries/use-system-languages";
import { FetchContext } from "../context/FetchContext";

const AddLanguagePopup = ({ projectId, onClose }) => {
  const [language, setLanguage] = React.useState(0);
  const fetchContext = useContext(FetchContext);

  const queryClient = useQueryClient();
  const { data: languages, isLoading: isLanguageLoading } =
    useSystemLanguages();
  const { mutateAsync, isLoading } = useMutation(
    async (languages) => {
      await fetchContext.authAxios.post(
        `/projects/${projectId}/languages`,
        languages
      );
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(["project", projectId, "languages"]);
      },
    }
  );

  const submit = async (e) => {
    e.preventDefault();
    await mutateAsync([
      {
        id: parseInt(language, 10),
      },
    ]);
    onClose();
  };

  if (isLanguageLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      className="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        />

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <form onSubmit={submit}>
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3
                    className="text-lg leading-6 font-medium text-gray-900"
                    id="modal-title"
                  >
                    Add language
                  </h3>
                  <div className="mt-2 text-sm text-gray-500">
                    <label className="block text-sm font-medium text-gray-700">
                      Languages
                    </label>
                    <div className="mt-1 flex rounded-md shadow-sm">
                      <select
                        value={language}
                        className="px-2 py-2 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md border"
                        onChange={(e) => setLanguage(e.target.value)}
                      >
                        <option value={0}>Please select</option>
                        {languages.map((language) => (
                          <option key={language.id} value={language.id}>
                            {language.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button
                type="submit"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Create
              </button>
              <button
                type="button"
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                onClick={() => onClose()}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddLanguagePopup;
